import { Icon } from "../icon/icon";
import React from "react";

import "./style.scss";

export const BackToTop = () => {
    const scrollToTop = () => {
        const scrollDuration = 200;
        const scrollStep = -getScrollTop() / (scrollDuration / 15);
        const scrollInterval = setInterval(() => {
            if (getScrollTop() !== 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    };

    const getScrollTop = () => {
        return window.pageYOffset;
    };

    return <div className={"back-to-top fade-in"}>
        <Icon icon="vertical_align_top" isRounded={true}
              onClick={() => scrollToTop()} />
    </div >;
};
